<template>
    <div class="verifiersettings spackage padding-20 bgc box-shadow" v-loading="loading">
        <section class="gc-header">
            <el-button type="primary" align="left" @click="createVF">新增核销员</el-button>
            <div align="right" style="float:right">
                <el-input placeholder="请输入核销员名称" v-model="searchName" style="width: 240px"></el-input>
                <el-button type="primary" @click="searchVF()" plain>搜索</el-button>
            </div>
        </section>

        <section>
            <el-table :data="tableData" header-row-class-name="tableHead">
                <!-- <el-table-column type="index" label="序号" align="left" width="100"> </el-table-column> -->
                <el-table-column prop="customername" label="用户名称" align="center" width="180"></el-table-column>
                <el-table-column prop="checkcount" label="核销单数" align="center"></el-table-column>
                <el-table-column prop="checkmoney" label="核销金额" align="center"></el-table-column>
                <el-table-column prop="datetime" label="创建时间" align="center" width="200"></el-table-column>
                <el-table-column prop="lastupdatetime" label="最后操作时间" align="center" width="200"></el-table-column>
                <el-table-column label="操作" align="right" width="120">
                    <template slot-scope="scope">
                        <div class="table-position">
                            <el-button @click="deleteVF(scope.row.innerid)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </section>
        <!-- end 表单 -->

        <!-- 新增核销员 弹窗 -- start -->
        <el-dialog title="新增核销员" :visible.sync="dialogFormVisible" class="verifier_box" @close="cancelSetting">
            <p>请输入需要绑定的核销员名称</p>
            <div class="verifier_name_box">
                <el-input placeholder="请输入用户名称" v-model="sAvailableName" style="width: 270px"></el-input>
                <el-button type="primary" @click="searchCreateVF()" plain>搜索</el-button>
            </div>
            <div class="verifier_list" :style="isThree ? 'justify-content: space-between' : 'justify-content: flex-start'">
                <div v-if="availableVFList.length>0" v-for="(item, index) in availableVFList" v-bind:key="index" :class="[verifier_item, item.selected ? isSelected : isDefault]" @click="selectVF(item.innerid, index)" :style="isThree ? '' : 'margin-right: 10px;'">
                    <img :src="item.customericonurl" :alt="item.customername" class="head_img">
                    <p>{{item.customername}}</p>
                    <div class="assname">{{item.assname}}</div>
                    <img v-if="item.selected" :src="blueArrow" class="blue_arrow">
                </div>
                <div v-if="isSearchNull" class="is_null">暂无数据</div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelSetting">取 消</el-button>
                <el-button type="primary" @click="sureAdd()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 新增核销员 弹窗 -- end -->

        <!-- 删除 -- 弹窗 -- start -->
        <el-dialog title="提示" :visible.sync="deleteDialog" width="25%" class="dele_dialog">
            <span class="dele_tips">确定要删除该核销员？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialog = false">取 消</el-button>
                <el-button type="primary" @click="deleteConfirm(deleteid)">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 删除 -- 弹窗 -- end -->

        <section>
            <el-pagination background layout="prev,pager,next" :total="rowCount"  @current-change="fPage()" :current-page.sync="currentPage" align="center" style="margin-top:20px"></el-pagination>
        </section>
        <!-- end 分页 -->
    </div>
</template>

<script>
import {getVerifierList, searchVerifierInfo, saveVerifier, deleteVerifier} from '@/api/cPurchaseApi'
import {getCookie} from '@/common/js/tools'
import {mapActions} from 'vuex'
// import Page from 'base/page/page'
import $ from 'jquery'

export default {
    name: 'verifierSettings',
    data() {
        return {
            form: {},
            loading: false,
            token: getCookie('token'),
            sessionUser: JSON.parse(sessionStorage['user']),
            shopID: JSON.parse(sessionStorage['shop']).ShopID,
            selectValue: '',
            currentPage: 1,
            rowCount: 0, // 数据条数
            page: 1, // 页数
            tableData: [], // 商品分类table数据
            dialogFormVisible: false,
            formLabelWidth: '80px',
            searchName: '',
            sAvailableName: '',
            availableVFList: [],
            isSelected: 'isSelected',
            isDefault: 'isDefault',
            verifier_item: 'verifier_item',
            blueArrow:  require('@/common/images/communityPurchases/blue_arrow.png'),
            currentidx: 0,
            currentid: '',
            deleteDialog: false,
            isThree: false,
            isSearchNull: false
        }
    },
    mounted() {
        // this.setLoading(true)
        this.getVFList(1, this.selectName ? this.selectName : '')
    },
    methods: {
        // 新增商品分类
        createVF() {
            this.dialogFormVisible = true
            this.sAvailableName = ''
        },
        
        // 获取核销员列表
        getVFList(page, name) {
            this.setLoading(true)
            let data = {
                customername: name,
                page: page,
                pageSize: 10
            }
            getVerifierList({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data.columnlist) {
                        this.tableData = data.data.columnlist
                        this.rowCount = data.data.pageinfo.rowCount
                    }
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },

        // 设置核销员
        selectVF(id, idx) {
            let list = this.availableVFList
            list[this.currentidx].selected = false
            this.currentidx = idx
            list[idx].selected = true
            this.availableVFList = list
            this.currentid = id
        },

        // 保存核销员
        sureAdd() {
            let data = {
                userinnerid: this.currentid
            }
            this.setLoading(true)
            saveVerifier({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.dialogFormVisible = false
                    this.availableVFList = []
                    this.getVFList(1, this.searchName ? this.searchName : '')
                    this.$message.success('核销员保存成功！')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 取消 关闭设置核销员
        cancelSetting() {
            this.dialogFormVisible = false
            this.availableVFList = []
            this.currentidx = 0
            this.isSearchNull = false
        },

        isMultiple(number){
            let isM = number % 3
            return isM === 0 ? true : false
        },

        // 删除核销员 弹窗
        deleteVF(id) {
            this.deleteDialog = true
            this.deleteid = id
        },

        // 删除核销员 接口调用
        deleteConfirm() {
            let data = {
                innerid: this.deleteid
            }
            this.setLoading(true)
            deleteVerifier({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.deleteDialog = false
                    this.getVFList(1, this.searchName ? this.searchName : '')
                    this.$message.success('删除成功')
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },
        
        // 搜索可绑定的核销员
        searchCreateVF() {
            this.setLoading(true)
            let data = {
                customername: this.sAvailableName
            }
            console.log(data)
            searchVerifierInfo({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data.columnlist.length > 0) {
                        this.isSearchNull = false
                        let list = data.data.columnlist
                        for (let i=0; i<list.length; i++) {
                            list[i].selected = false
                        }
                        this.availableVFList = list
                        this.isThree = this.isMultiple(this.availableVFList.length)
                    } else {
                        console.log('kong')
                        this.isSearchNull = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },

        // 搜索核销员
        searchVF() {
            this.getVFList(1, this.searchName)
        },

        // 分页加载
        fPage() {
            this.setLoading(true)
            let clickPage = $('.el-pagination .active').html()
            this.getVFList(clickPage, this.searchName ? this.searchName : '')
        },

        ...mapActions([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/starmgt";
    .tableHead {
        font-weight: bold;
    }
    .isSelected {
        border: 1px solid #409EFF;
    }
    .isDefault {
        border: 1px solid #E4E7ED;
    }
    .verifiersettings {
        .el-dialog__body {
            text-align: center;
        }
        .verifier_box {
            .el-dialog {
                width: 550px;
                height: 620px;
                .el-button {
                    margin-bottom: 0;
                }
                .el-dialog__body {
                    // text-align: center;
                    // padding: unset;
                    .verifier_name_box {
                        width: 390px;
                        // height: 235px;
                        display: -webkit-flex;
                        justify-content: space-between;
                        margin: 20px auto;
                    }
                    .verifier_list {
                        width: 100%;
                        height: 385px;
                        overflow-y: auto;
                        display: flex;
                        // justify-content: space-between;
                        flex-wrap: wrap;
                        .verifier_item {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            width: 155px;
                            height: 160px;
                            border-radius: 4px;
                            position: relative;
                            margin-bottom: 20px;
                            img {
                                display: inline-block;
                            }
                            .head_img {
                                width: 80px;
                                height: 80px;
                                border-radius: 50%;
                                margin-top: 15px;
                            }
                            .blue_arrow {
                                position: absolute;
                                width: 30px;
                                height: 30px;
                                top: 0;
                                left: 0;
                            }
                            p {
                                font-size: 14px;
                                color: #303133;
                                margin-top: 10px;
                            }
                            div {
                                width: 140px;
                                height: 30px;
                                line-height: 16px;
                                margin-top: 5px;
                                overflow: hidden;
                            }
                        }
                        .verifier_item:nth-child(3n) {
                            margin-right: unset !important;
                        }
                        .is_null {
                            width: 100%;
                            margin-top: 20px;
                            text-align: center;
                            color: #999;
                        }
                    }
                }
            }
        }
        .el-table {
            .sub-title {
                display: -webkit-box;
                max-height: 40px;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                -moz-box-orient: vertical;
                -ms-box-orient: vertical;
                box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }

        }
        .gc-header {
            height: 40px;
            margin-bottom: 30px;
            .el-input__icon {
                height: 36px ;
            }
            .el-select,
            .el-select>.el-input,
            .el-button {
                height: 32px;
            }
            .el-select {
                width: 116px;
            }
            .el-select,
            .el-input {
                margin-right: 20px;
            }
        }

        .table-title {
            img {
                width: 106px;
                height: 60px;
            }

            .table-txt {
                display: block;
                width: calc(100% - 126px);
                height: 70px;
                p {
                    width: 100%;
                    height: 40px;
                }
            }

        }
        .table-position {
            .el-dropdown-link {
                a {
                    color: #303133;
                }
            }
        }
    }
</style>
